import React from 'react';

const SolProfile = () => {
  return <h1>SolProfile Page</h1>;
};

export default SolProfile;
